import {
  ActionType,
  IVoiceCallPayload,
  IVoiceCallResponse,
} from "models/setting/voiceCall";

export const voiceCallAction = (payload: IVoiceCallPayload) => {
  return {
    type: ActionType.VOICE_CALL,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.VOICE_CALL_ERROR,
    payload,
  };
};

export const handleSuccessAction = (payload: IVoiceCallResponse) => {
  return {
    type: ActionType.VOICE_CALL_SUCCESS,
    payload,
  };
};

export const handleResetAction = () => {
  return {
    type: ActionType.VOICE_CALL_RESET,
  };
};
